import React from 'react';
import { SectionIntroStyles as S } from './SectionIntro.styles';
import Breadcrumbs from '@stories/Widgets/Breadcrumbs/Breadcrumbs';
import { renderHighlightedText } from '@helpers/highlightedText';
const TitleTag = ({ useH1, children, }) => {
    const Tag = useH1 ? 'h1' : 'h2';
    return React.createElement(Tag, null, children);
};
const SectionIntro = (props) => {
    return (React.createElement(S.Container, { "data-smaller-text": props.smallerText },
        props.breadcrumbsProps && React.createElement(Breadcrumbs, { ...props.breadcrumbsProps, noPadding: true }),
        React.createElement(TitleTag, { useH1: props.useH1 }, renderHighlightedText(props.title)),
        props.intro && React.createElement("p", null, props.intro)));
};
export default SectionIntro;
